import { decryptData, defaulUrl, fmt } from "../components/const";
import { useEffect, useRef, useState } from "react";
import UseFetch from '../components/UseFetch';
import Select from "react-select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Fonction générique d'export PDF

const VenteParConteneur = ({ id }) => {
    if (!id) {
        id = decryptData('user_profile').idmagasin;
    }

    const { data: conteneurs, isloading } = UseFetch(`approvisions/vendu/${id}`);
    const [isLoading, setIsLoading] = useState(false);
    const [ventePeriode, setVentesPeriode] = useState(null);
    const [totalqte, setTotalQte] = useState(0);
    const [totalmontant, setTotalMontant] = useState(0);
    const [conteneur, setConteneur] = useState(null);
    const [error, setError] = useState(null);
    const [copieListe, setCopieListe] = useState(null);
    const [produits, setProduits] = useState(null);
    const [selectedProduit, setSelectedProd] = useState(null);
    const [client_dette, setClientDette] = useState(null);
    const [factures_imp, setFacturesImp] = useState(null);
    const [paie_recouvrement, setPaie] = useState(null);
    const [detail, setDetail] = useState(null);
    const [isSearched, setIsSearched] = useState(false);

    const printElement = useRef();
    const printFacturesImp = useRef();
    const printCltDette = useRef();
    const printPaies = useRef();
    const printDetail = useRef();

    let totalRemiseSurplus = 0;

    const handleShowVentesConteneur = (idconteneur) => {
        if (!conteneur) {
            setError('Veuillez choisir un conteneur');
            return;
        }
        setError(null);
        setIsLoading(true);
        let status = 0;

        fetch(`${defaulUrl}ventes/conteneur/${idconteneur}`, {
            method: "GET",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            }
        })
            .then(res => {
                status = res.status;
                return res.json();
            })
            .then(data => {
                setIsLoading(false);
                if (status === 200) {
                    setIsSearched(true);
                    data?.ventes?.sort((a, b) => a.conteneur.localeCompare(b.conteneur));
                    setVentesPeriode(data.ventes);
                    setCopieListe(data.ventes);

                    const prods = data?.ventes?.map(p => ({ produit: p.produit }));
                    setProduits([...new Map(prods?.map(o => [o?.produit, o]))?.values()]);

                    setClientDette(data?.clients_dette);
                    setFacturesImp(data?.facturesImpayees);
                    setPaie(data?.paiements);
                    setDetail(data?.detail);
                }
            });
    };

    const handleSearch = () => {
        const saisie = selectedProduit?.value?.toUpperCase();
        if (!saisie) return;

        setVentesPeriode(copieListe?.filter(p => p.produit?.toUpperCase().includes(saisie)));
    };

    useEffect(() => {
        if (ventePeriode?.length) {
            setTotalQte(ventePeriode.reduce((prev, curr) => prev + parseFloat(curr.quantite), 0));
            setTotalMontant(ventePeriode.reduce((prev, curr) => prev + parseFloat(curr.montant), 0));
        }
    }, [ventePeriode]);
    // Ajoute cette fonction pour exporter tout en un PDF
    const exportAllPDF = () => {
        const doc = new jsPDF("l", "pt");
        const pageWidth = doc.internal.pageSize.getWidth();
        let startY = 20;

        const addSection = (title, columns, rows) => {
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 128);
            doc.text(title, 20, startY);
            startY += 10;

            autoTable(doc, {
                startY,
                head: [columns.map(c => c.header)],
                body: rows.map(r => columns.map(c => r[c.dataKey])),
                theme: "grid",
                styles: { fontSize: 9 },
                headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
                didDrawPage: () => {
                    const pageNumber = doc.internal.getNumberOfPages();
                    doc.setFontSize(8);
                    doc.text(`Page ${pageNumber}`, pageWidth - 40, doc.internal.pageSize.getHeight() - 10, { align: "right" });
                }
            });
            startY = doc.lastAutoTable.finalY + 20;
        };

        // --- Produits vendus ---
        if (ventePeriode?.length) {
            let totalRem = 0;
            const columns = [
                { header: "N°", dataKey: "index" },
                { header: "PRODUIT", dataKey: "produit" },
                { header: "QTE", dataKey: "quantite" },
                { header: "PVU", dataKey: "pvu" },
                { header: "MONTANT", dataKey: "montant" },
                { header: "SUP/REMISE", dataKey: "variation" },
                { header: "M SUP/REMISE", dataKey: "montantVariation" },
                { header: "CLIENT", dataKey: "client" },
                { header: "VENDEUR", dataKey: "vendeur" },
                { header: "DATE", dataKey: "created_at" }
            ];
            const rows = ventePeriode.map((p, i) => {
                const remise = parseFloat(p.variation) * parseFloat(p.quantite || 0);
                totalRem += remise;
                return {
                    index: i + 1,
                    produit: p.produit,
                    quantite: p.quantite,
                    pvu: fmt(p.pvu),
                    montant: fmt(p.montant),
                    variation: fmt(p.variation),
                    montantVariation: fmt(remise),
                    client: p.client,
                    vendeur: p.vendeur?.toUpperCase(),
                    created_at: p.created_at
                };
            });
            addSection(`Produits vendus - Conteneur: ${conteneur?.label?.toUpperCase()}`, columns, rows);
        }

        // --- Factures impayées ---
        if (factures_imp?.length) {
            const columns = [
                { header: "N°FACTURE", dataKey: "numero" },
                { header: "CLIENT", dataKey: "client" },
                { header: "MONTANT", dataKey: "montant" },
                { header: "PAYE", dataKey: "paye" },
                { header: "RESTE", dataKey: "reste" }
            ];
            const rows = factures_imp.map(f => ({
                numero: f.numero,
                client: f.client,
                montant: fmt(f.montant),
                paye: fmt(f.paye),
                reste: fmt(f.reste)
            }));
            addSection("Factures impayées", columns, rows);
        }

        // --- Clients en dette ---
        if (client_dette?.length) {
            const columns = [
                { header: "N°", dataKey: "index" },
                { header: "CLIENT", dataKey: "client" },
                { header: "TELEPHONE", dataKey: "telephone" },
                { header: "TOTAL FACTURES", dataKey: "Montant" },
                { header: "TOTAL PAYE", dataKey: "Paye" },
                { header: "TOTAL RESTE", dataKey: "Reste" }
            ];
            const rows = client_dette.map((c, i) => ({
                index: i + 1,
                client: c.client,
                telephone: c.telephone,
                Montant: fmt(c.Montant),
                Paye: fmt(c.Paye),
                Reste: fmt(c.Reste)
            }));
            addSection("Clients en dette", columns, rows);
        }

        // --- Paiements / Recouvrements ---
        if (paie_recouvrement?.length) {
            const columns = [
                { header: "N°", dataKey: "index" },
                { header: "CLIENT", dataKey: "client" },
                { header: "N°FACTURE", dataKey: "numero" },
                { header: "MONTANT", dataKey: "montant" },
                { header: "MODE PAIE", dataKey: "mode_paie" },
                { header: "TYPE OPER", dataKey: "type" },
                { header: "DATE", dataKey: "created_at" }
            ];
            const rows = paie_recouvrement.map((p, i) => ({
                index: i + 1,
                client: p.client,
                numero: p.numero,
                montant: fmt(p.montant),
                mode_paie: p.mode_paie,
                type: p.type,
                created_at: p.created_at
            }));
            addSection("Paiements / Recouvrements", columns, rows);
        }

        // --- Détail ventes ---
        // if (detail?.length) {
        //     const columns = [
        //         { header: "MONTANT VENTE", dataKey: "M_VENTE" },
        //         { header: "MONTANT REMISE", dataKey: "M_REMISE" },
        //         { header: "MONTANT SUR PLUS", dataKey: "M_SUR_PLUS" },
        //         { header: "TOTAL NET A PAYER", dataKey: "M_NET" },
        //         { header: "MONTANT PAYE", dataKey: "M_PAYE" },
        //         { header: "MONTANT IMPAYE", dataKey: "M_RESTE" }
        //     ];
        //     const rows = detail.map(d => ({
        //         M_VENTE: fmt(d.M_VENTE),
        //         M_REMISE: fmt(d.M_REMISE),
        //         M_SUR_PLUS: fmt(d.M_SUR_PLUS),
        //         M_NET: fmt(d.M_NET),
        //         M_PAYE: fmt(d.M_PAYE),
        //         M_RESTE: fmt(d.M_RESTE)
        //     }));
        //     addSection("Détail ventes", columns, rows);
        // }

        doc.save(`Conteneur_${conteneur?.label?.toUpperCase()}.pdf`);
    };

    return (
        <div className="container-fluid">
            <h3>LISTE DES VENTES PAR CONTENEUR</h3>

            <div className="row p-2 text-primary my-2">


                <Select className="w-50"
                    placeholder="Choisir un conteneur"
                    defaultInputValue={conteneur?.label}
                    options={conteneurs?.map(c => ({ value: `${c.id}`, label: `${c.conteneur}` }))}
                    onChange={setConteneur}
                />

                <button className="btn btn-sm btn-primary w-auto " onClick={() => handleShowVentesConteneur(conteneur?.value)}>
                    <i className="bx bx-show"></i>
                </button>
                {error && <span className="text-danger">{error}</span>}

                <button className="btn btn-sm btn-primary w-auto ms-auto" onClick={() => exportAllPDF()}>
                    <i className="bx bx-printer"></i> Exporter pdf
                </button>
            </div>

            {isSearched ? (
                <div>

                    {/* --- PRODUITS VENDUS --- */}
                    <div className="mb-4">
                        <div className="row py-1 align-items-end">

                            <Select className="w-25"
                                defaultInputValue={selectedProduit?.label}
                                placeholder="Trier par produit"
                                options={produits?.map(p => ({ value: p.produit, label: p.produit }))}
                                onChange={setSelectedProd}
                            />


                            <button className="btn btn-primary ms-2 w-auto" onClick={handleSearch}>
                                <i className="bx bx-search"></i>
                            </button>

                        </div>

                        <div className="table-responsive" ref={printElement}>
                            {ventePeriode?.length > 0 && (
                                <table className="table table-hover table-striped table-bordered table-sm">
                                    <thead className="table-dark">
                                        <tr className="text-center small">
                                            <th>N°</th>
                                            <th>PRODUIT</th>
                                            <th>QTE</th>
                                            <th>PVU</th>
                                            <th>MONTANT</th>
                                            <th>SUP/REMISE</th>
                                            <th>M SUP/REMISE</th>
                                            <th>CLIENT</th>
                                            <th>VENDEUR</th>
                                            <th>DATE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ventePeriode.map((prod, ind) => {
                                            const remise = parseFloat(prod?.variation) * parseFloat(prod?.quantite);
                                            totalRemiseSurplus += remise;
                                            return (
                                                <tr key={ind}>
                                                    <td>{ind + 1}</td>
                                                    <td>{prod.produit}</td>
                                                    <td>{prod.quantite}</td>
                                                    <td>{prod.pvu.toLocaleString()}</td>
                                                    <td>{prod.montant.toLocaleString()}</td>
                                                    <td>{parseFloat(prod.variation).toLocaleString()}</td>
                                                    <td>{remise.toLocaleString()}</td>
                                                    <td>{prod.client}</td>
                                                    <td>{prod.vendeur?.toUpperCase()}</td>
                                                    <td>{prod.created_at}</td>
                                                </tr>
                                            );
                                        })}
                                        <tr className="fw-bold bg-secondary-subtle text-center">
                                            <td colSpan={2}>Totaux</td>
                                            <td>{totalqte}</td>
                                            <td></td>
                                            <td>{totalmontant.toLocaleString()} GNF</td>
                                            <td></td>
                                            <td>{totalRemiseSurplus.toLocaleString()} GNF</td>
                                            <td colSpan={3}></td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>

                    {/* --- FACTURES IMPAYEES --- */}
                    <div className="mb-4">
                        <h5>Factures impayées</h5>

                        {factures_imp?.length > 0 ? <div className="table-responsive" ref={printFacturesImp}>
                            <table className="table table-striped table-hover">
                                <thead className="table-danger">
                                    <tr>
                                        <td>N°FACTURE</td>
                                        <td>CLIENT</td>
                                        <td>MONTANT</td>
                                        <td>PAYE</td>
                                        <td>RESTE</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {factures_imp?.map((fac, ind) =>
                                        <tr key={ind}>
                                            <td>{fac.numero}</td>
                                            <td>{fac.client}</td>
                                            <td>{fac.montant?.toLocaleString()} GNF</td>
                                            <td>{fac.paye?.toLocaleString()} GNF</td>
                                            <td>{fac.reste?.toLocaleString()} GNF</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div> : <div className="text-center py-2 text-success fs-5">Aucune facture impayée</div>}
                    </div>

                    {/* --- CLIENTS EN DETTE --- */}
                    <div className="mb-4">
                        <h5>Clients en dette</h5>

                        {client_dette?.length > 0 ? <div className="table-responsive" ref={printCltDette}>
                            <table className="table table-striped table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <td>N° </td>
                                        <td>CLIENT</td>
                                        <td>TELEPHONE</td>
                                        <td>TOTAL FACTURES</td>
                                        <td>TOTAL PAYE</td>
                                        <td>TOTAL RESTE</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {client_dette?.map((cl, ind) =>
                                        <tr key={ind}>
                                            <td>{ind + 1}</td>
                                            <td>{cl.client}</td>
                                            <td>{cl.telephone}</td>
                                            <td>{cl.Montant?.toLocaleString()} GNF</td>
                                            <td>{cl.Paye?.toLocaleString()} GNF</td>
                                            <td>{cl.Reste?.toLocaleString()} GNF</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div> : <div className="text-center py-2 text-success fs-5">Aucun client en dette pour ce conteneur</div>}
                    </div>

                    {/* --- PAIEMENTS / RECOUVREMENTS --- */}
                    <div className="mb-4">
                        <h5>Reglements et Recouvrements factures</h5>

                        {paie_recouvrement?.length > 0 ? <div className="table-responsive" ref={printPaies}>
                            <table className="table table-striped table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <td>N° </td>
                                        <td>CLIENT</td>
                                        <td>N°FACTURE</td>
                                        <td>MONTANT</td>
                                        <td>MODE PAIE</td>
                                        <td>TYPE OPER</td>
                                        <td>DATE</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paie_recouvrement?.map((paie, ind) =>
                                        <tr key={ind}>
                                            <td>{ind + 1}</td>
                                            <td>{paie.client}</td>
                                            <td>{paie.numero}</td>
                                            <td>{paie.montant?.toLocaleString()} GNF</td>
                                            <td>{paie.mode_paie}</td>
                                            <td>{paie.type}</td>
                                            <td>{paie.created_at}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div> : <div className="text-center py-2 text-success fs-5">Aucun paiement/recouvrement pour ce conteneur</div>}
                    </div>

                    {/* --- DETAIL VENTES --- */}
                    <div className="mb-4" hidden>
                        <h5>Détail ventes</h5>

                        <div className="table-responsive" ref={printDetail}>
                            <table className="table table-hover table-striped table-bordered ">
                                <thead className="table-dark">
                                    <tr className="align-middle text-center">
                                        <th>MONTANT VENTE</th>
                                        <th>MONTANT REMISE</th>
                                        <th>MONTANT SUR PLUS</th>
                                        <th>TOTAL NET A PAYER</th>
                                        <th>MONTANT PAYE</th>
                                        <th>MONTANT IMPAYE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {detail?.map((d, ind) =>
                                        <tr key={ind}>
                                            <td>{d.M_VENTE?.toLocaleString()} GNF</td>
                                            <td>{d.M_REMISE?.toLocaleString()} GNF</td>
                                            <td>{d.M_SUR_PLUS?.toLocaleString()} GNF</td>
                                            <td>{d.M_NET?.toLocaleString()} GNF</td>
                                            <td>{d.M_PAYE?.toLocaleString()} GNF</td>
                                            <td>{d.M_RESTE?.toLocaleString()} GNF</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            ) : (
                <div className="text-center bg-info-subtle text-info p-2 fs-3">
                    Choisissez un conteneur pour voir les détails
                </div>
            )}

            {isLoading && <div className="loader"></div>}
        </div>
    );
};

export default VenteParConteneur;
